import AuthWrapperRegisterNew from '~/sections/auth/AuthWrapperRegisterNew';
import AuthRegisterCognitoNew from '~/sections/auth/auth-forms/AuthRegisterCognitoNew';

/**
 * Route component for /register.
 *
 * Renders the email registration form.
 *
 * `@example`
 * <EmailRegistrationRoute />
 */
const EmailRegistrationRoute = () => {
  return (
    <AuthWrapperRegisterNew>
      <AuthRegisterCognitoNew />
    </AuthWrapperRegisterNew>
  );
};

export default EmailRegistrationRoute;
